<div class="flex flex-col h-full max-h-[80vh]">
    <div class="flex items-center justify-between px-6 pt-8 pb-4">
        <p class="text-[1.125rem] text-[#0A0A0A] font-bold">Badges</p>
        <div class="flex items-center gap-3">
            <div class="flex items-center gap-2 bg-[#E6EAFF] rounded-full px-4 py-2">
                <img src="/assets/images/shared/seed-icon.svg" alt="Seed Icon" class="h-5 w-auto" />
                <span class="text-sm font-semibold">{{ getUserProfileDetails()?.coin }}</span>
            </div>
            <img
                src="/assets/images/shared/cross-black-icon.svg"
                alt="Close Icon"
                class="h-4 w-auto cursor-pointer"
                (click)="onCancel()" />
        </div>
    </div>

    <div class="flex-1 overflow-y-auto px-4 sm:px-6 py-3 sm:py-4 border-t border-[#E7EAF0]">
        <div class="grid grid-cols-3 sm:grid-cols-4 gap-3 sm:gap-4">
            @for (badge of badges(); track badge.id) {
                <div
                    class="flex flex-col items-center justify-center gap-1.5 sm:gap-2 p-3 sm:p-4 rounded-xl sm:rounded-2xl cursor-pointer"
                    [ngClass]="badge === selectedBadge ? 'bg-[#4F66FF80]' : ''"
                    (click)="selectBadge(badge)">
                    <img class="h-10 w-10 sm:h-12 sm:w-12 object-contain" [src]="badge.photo" [alt]="badge.name" />
                    <span class="text-xs sm:text-sm text-gray-600">{{ badge.coin }}</span>
                </div>
            }
        </div>
    </div>

    @if (selectedBadge) {
        <div class="bg-[#4F66FF33] px-6 py-4 flex-shrink-0">
            <div class="flex items-center justify-between">
                <div class="flex items-center gap-3 pl-6">
                    <img class="h-10 w-10 object-contain" [src]="selectedBadge.photo" [alt]="selectedBadge.name" />
                    <div>
                        <p class="font-semibold text-sm">{{ selectedBadge.name }}</p>
                        <p class="text-xs text-gray-600">{{ selectedBadge.description }}</p>
                    </div>
                </div>
                <div class="flex items-center gap-2 bg-[#E6EAFF] rounded-full px-4 py-2">
                    <img src="/assets/images/shared/seed-icon.svg" alt="Seed Icon" class="h-5 w-auto" />
                    <span class="text-sm font-semibold">{{ selectedBadge.coin }}</span>
                </div>
            </div>
        </div>

        <div class="px-6 py-4 flex-shrink-0">
            <button type="button" class="w-full py-3 border-button" (click)="sendBadge()">Send Badge</button>
        </div>
    }
</div>
